document.addEventListener("alpine:init", () => {
  Alpine.data("customEmarsysBisForm", () => ({
    loading: false,
    email: "",
    errMsg: "",
    checked: false,
    isSuccess: false,
    errorMsgUnchecked: "Please tick agreement boxes to proceed.",
    errorMsgEmailInvalid: "Email: invalid format!",
    errorMsgOther: "Oops... Something went wrong, please refresh and try again.",

    init() {
      const ds = this.$el?.dataset || {};
      if (ds.errorMsgUnchecked) this.errorMsgUnchecked = ds.errorMsgUnchecked;
      if (ds.errorMsgEmailInvalid)
        this.errorMsgEmailInvalid = ds.errorMsgEmailInvalid;
      if (ds.errorMsgOther) this.errorMsgOther = ds.errorMsgOther;
    },

    async submitResult() {
      if (!this.checked) {
        this.errMsg = this.errorMsgUnchecked;
        return;
      }
      const isEmailValid = validateEmail(this.email);
      if (!isEmailValid) {
        this.errMsg = this.errorMsgEmailInvalid;
        return;
      }
      // If no error, remove error message
      this.errMsg = "";

      const fieldsArray = createFieldsArray(customEmarsysBisFormSettingJsons);
      // getContactListId function in subscription-form-common.js
      const contactListId = getContactListId(customEmarsysBisFormSettingJsons);

      // Extract theme global variables from theme.liquid
      const { apiUrl, acceptedLanguage, apiKey, xAppid } =
        theme.emailSubscription;

      const subscribeInfoCookie = window.getCookieForEmarsys('subscribe_info');
      let eventTracking = null;

      if (subscribeInfoCookie) {
        try {
          const decodedCookie = decodeURIComponent(subscribeInfoCookie)
          eventTracking = JSON.parse(decodedCookie);
          delete eventTracking.ts
          console.log('eventTracking', eventTracking);
        } catch (error) {
          console.log('eventTracking error', subscribeInfoCookie);
          console.warn('Failed to parse subscribe_info cookie:', error);
        }
      };

      const apiBody = {
        email: this.email,
        contactListId,
        fields: fieldsArray,
        ...(eventTracking && { eventTracking }),
      };
      this.loading = true;
      try {
        const response = await fetch(
          // Header global settings are defined in star-email-subscription-form.liquid
          // Except traceId is defined in subscription-form-common.js
          apiUrl,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              apiKey: apiKey,
              traceId: traceId,
              "X-appid": xAppid,
              "Accepted-Language": acceptedLanguage,
            },
            body: JSON.stringify(apiBody),
          }
        );

        const data = await response.json();

        if (data.message === "Success") {
          this.isSuccess = true;
        }else {
           this.errMsg = msg.apiError;
        }
      } catch (error) {
        this.errMsg = this.errorMsgOther;
      } finally {
        this.loading = false;
      }
    },
  }));
});
